module.exports = __webpack_public_path__ + "static/img/yytx16.aaf261f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx16.png
// module id = 888
// module chunks = 0